import React from "react";
import { Heart, ShieldCheck, Apple, Palette, GraduationCap, Users } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Live 1-on-1 Lessons",
  description: "Personalized attention ensures your child stays focused and receives the perfect level of challenge in every session.",
  icon: Users,
  color: "text-[var(--chart-2)]"
}, {
  title: "Playful Teachers",
  description: "Our energetic instructors are experts at keeping kids laughing and learning through songs and joyful storytelling.",
  icon: Heart,
  color: "text-[var(--chart-1)]"
}, {
  title: "Confidence Building",
  description: "We celebrate every small win, helping children feel brave enough to start speaking Spanish from their very first day.",
  icon: GraduationCap,
  color: "text-[var(--chart-3)]"
}, {
  title: "Flexible Scheduling",
  description: "Life is busy! Easily book or reschedule lessons to fit your family's unique routine without any added stress.",
  icon: ShieldCheck,
  color: "text-[var(--chart-4)]"
}, {
  title: "Fun & Structured",
  description: "Our curriculum blends playful games with a clear roadmap, ensuring real progress while having a total blast.",
  icon: Palette,
  color: "text-[var(--chart-1)]"
}, {
  title: "Magical Adventures",
  description: "We turn language learning into an imaginative journey that sparks curiosity and a lifelong love for new cultures.",
  icon: Apple,
  color: "text-[var(--chart-2)]"
}];
export default function WhyFamiliesLoveUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="41123" id="why-families-love-linguakids" className="bg-background py-24 relative overflow-hidden dark">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-[var(--chart-1)]/10 rounded-full blur-3xl" />
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-[var(--chart-3)]/10 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-4 tracking-tight">
            Why Families Love LinguaKids
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto font-sans">
            We go above and beyond to create a playful, engaging, and safe
            magical environment for your little learners to thrive.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {features.map((feature, i) => <div key={i} data-index={i} className="h-full">
              <Card className="h-full bg-card border-4 border-secondary/10 shadow-md hover:shadow-2xl hover:-translate-y-3 transition-all duration-500 rounded-[40px] group overflow-hidden">
                <CardContent className="p-12 flex flex-col items-start gap-6 h-full">
                  <div className={`p-5 rounded-3xl bg-background/80 ${feature.color} shadow-sm transition-transform duration-500 ease-out group-hover:scale-110 group-hover:-rotate-12`}>
                    <feature.icon className="w-10 h-10 stroke-[2]" />
                  </div>
                  
                  <div className="space-y-3">
                    <h3 className="text-2xl font-bold text-foreground group-hover:text-primary transition-colors duration-300 font-sans">
                      {feature.title}
                    </h3>
                    <p className="text-lg text-muted-foreground leading-relaxed font-sans">
                      {feature.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}